export default {
  BLUE: "blue",
  ORANGE: "orange",
  GRAY: "gray",
  WHITE: "white"
};
